import { QuantityValidation } from "../../../../components/validate";

export function getProductDealerCode(product) {
    return String(product?.dealerCode || "").trim();
}

export function hasMixedDealerCodes(selectedProducts) {
    const dealerCodes = selectedProducts
        .map(getProductDealerCode)
        .filter(Boolean);

    return new Set(dealerCodes).size > 1;
}

export function validateRecipient(recipient, { isManualRecipient, recipientItems, validateLe })
{
    const errors = {};

    const itemsToValidate = isManualRecipient
        ? recipientItems
        : recipientItems.filter(item => item.id === "province");

    const excludedFields = new Set([
        "selectedDealer",
        "recipientCode"
    ]);

    itemsToValidate.forEach(item => {
        if (excludedFields.has(item.id)) {
            return;
        }

        const value = recipient?.[item.id];

        const normalizedValue =
            typeof value === "string"
                ? value.trim()
                : value;

        const isEmpty = normalizedValue === "" || normalizedValue === null || normalizedValue === undefined;

        if (item.mandatory && isEmpty) {
            errors[item.id] = `${item.text} ${validateLe.required}`;
            return;
        }

        if (isEmpty || typeof item.validate !== "function") {
            return;
        }

        const validationMessage = item.id === "zip"
                ? item.validate(item.text, normalizedValue, recipient?.country)
                : item.validate(item.text, normalizedValue);

        if (validationMessage) {
            errors[item.id] = validationMessage;
        }
    });

    return errors;
}

export function validateOrderInfo(orderInfo, { orderInfoConfig, validateLe, le }
) {
    const errors = {};

    const rawReference = String(orderInfo?.orderReference || "");
    const reference = rawReference.trim();
    const notes = String(orderInfo?.notes || "").trim();

    if (orderInfoConfig.referenceMandatory && !reference) {
        errors.orderReference = `${orderInfoConfig.referenceLabel} ${validateLe.required}`;
    } else if (/[\\/:*?"<>|\s]/.test(rawReference)) {
        errors.orderReference = le.errors.referenceOrdersCharactersNotAllowed;
    } else if (reference.length > orderInfoConfig.referenceMaxLength) {
        errors.orderReference = `${orderInfoConfig.referenceLabel} ${validateLe.tooLong}`;
    }

    if (orderInfoConfig.notesMandatory && !notes) {
        errors.notes = `${orderInfoConfig.notesLabel} ${validateLe.required}`;
    } else if (notes.length > orderInfoConfig.notesMaxLength) {
        errors.notes = `${orderInfoConfig.notesLabel} ${validateLe.tooLong}`;
    }

    return errors;
}

export function validateSelectedItems(
    selectedProducts,
    { le }
) {
    const errors = {
        global: [],
        quantity: {}
    };

    if (!selectedProducts.length) {
        errors.global.push(le.errors.nothingSelected);
        return errors;
    }

    if (hasMixedDealerCodes(selectedProducts)) {
        errors.global.push(le.errors.differentDealerCode);
    }

    selectedProducts.forEach(product => {
        const { error } = QuantityValidation(
            product.SKU,
            product.quantity,
            product.avaibleQuantity
        );

        if (error) {
            errors.quantity[product.id] = error;
        }
    });

    return errors;
}